import api from './client'

export interface TableColumnTemplate {
  name: string
  instruction: string
}

export interface AIBatchAnalyzeRequest {
  search_id?: string
  dataset_id?: string
  data?: Record<string, any>[]
  question: string
  output_format?: 'text' | 'table'
  detail_level?: 'normal' | 'detailed'
  temperature?: number
  max_rows?: number
  row_selection?: 'top' | 'random'
  table_template?: TableColumnTemplate[]
}

export interface RegexBuildRequest {
  description: string
  context?: string
}

export interface RegexBuildResponse {
  pattern: string
  explanation: string
  suggestions: string[]
}

export interface AnalysisImage {
  image_id: string
  analysis_id: string
  image_base64: string
  image_mime: string
  prompt?: string
  is_primary: boolean
  created_at: string
}

export interface AnalysisResponse {
  analysis_id: string
  user_id: string
  session_id?: string
  search_id?: string
  dataset_id?: string
  name: string
  analysis_type: string
  params?: Record<string, any>
  results?: {
    text?: string
    table_data?: Record<string, any>[]
    image_base64?: string
    image_mime?: string
  }
  images?: AnalysisImage[]
  status: string
  error_message?: string
  created_at: string
}

export const aiApi = {
  getConfig: () => api.get<{ max_rows: number }>('/ai/config'),
  batchAnalyze: (data: AIBatchAnalyzeRequest) =>
    api.post<{ analysis_id: string; status: string; message: string }>('/ai/batch-analyze', data),
  buildRegex: (data: RegexBuildRequest) =>
    api.post<RegexBuildResponse>('/ai/build-regex', data),
  getAnalysis: (analysisId: string) => api.get<AnalysisResponse>(`/ai/batch-analyze/${analysisId}`),
  listAnalyses: (sessionId?: string) => api.get<AnalysisResponse[]>('/ai/analyses', {
    params: sessionId ? { session_id: sessionId } : undefined,
  }),
  cancelAnalysis: (analysisId: string) =>
    api.post<{ message: string }>(`/ai/batch-analyze/${analysisId}/cancel`, {}),
  deleteAnalysis: (analysisId: string) =>
    api.delete<{ message: string }>(`/ai/batch-analyze/${analysisId}`),
  generateImage: (analysisId: string) =>
    api.post<{ image_id: string; image_base64: string; image_mime: string; prompt: string; is_primary: boolean; created_at: string; cost: number }>(`/ai/batch-analyze/${analysisId}/generate-image`, {}),
  refineImage: (analysisId: string, prompt: string) =>
    api.post<{ image_id: string; image_base64: string; image_mime: string; prompt: string; is_primary: boolean; created_at: string; cost: number }>(`/ai/batch-analyze/${analysisId}/refine-image`, { prompt }),
}
